export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.209 19.39a.75.75 0 01-.75.75h-6.61a6.344 6.344 0 01-6.343-6.343h.75-.75A6.375 6.375 0 019.88 7.422h8.434l-1.61-1.46a.75.75 0 011.009-1.111l3.047 2.766a.75.75 0 01.006 1.105l-3.047 2.828a.75.75 0 11-1.02-1.1l1.646-1.528H9.88a4.875 4.875 0 00-4.874 4.875 4.844 4.844 0 004.843 4.844h6.61a.75.75 0 01.75.75z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};